export default "__VITE_ASSET__d1233338__"